export default __webpack_public_path__ + "static/media/From Different Perspectives 2017 -- Charcoal on Paper -- 48in x 66in.d473bab4.jpg";